import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from './ui/button';

// Section shape: { title, p: [paragraphs], list?: [bullets], after?: [paragraphs] }
export const LegalSection = ({ n, s, prefix }) => (
  <section data-testid={`${prefix}-section-${n}`}>
    <h2 className="text-2xl font-bold text-gray-900 mb-4">{n}. {s.title}</h2>
    {s.p.map((t, i) => <p key={i} className="text-gray-600 mb-4">{t}</p>)}
    {s.list && (
      <ul className="list-disc pl-6 text-gray-600 mb-4 space-y-2">
        {s.list.map((li, i) => <li key={i}>{li}</li>)}
      </ul>
    )}
    {(s.after || []).map((t, i) => <p key={i} className="text-gray-600 mb-4">{t}</p>)}
    <div className="mb-4" />
  </section>
);

export const LegalHero = ({ icon: Icon, title, date, prefix }) => (
  <section className="pt-32 pb-12 px-4 bg-gradient-to-br from-teal-900 via-teal-800 to-gray-900 text-white">
    <div className="container mx-auto">
      <div className="flex items-center space-x-2 mb-4">
        <Icon className="text-teal-400" size={28} />
        <span className="text-teal-400 font-semibold text-sm uppercase tracking-wider">Legal</span>
      </div>
      <h1 className="text-4xl md:text-5xl font-bold mb-4">{title}</h1>
      <p className="text-gray-300" data-testid={`${prefix}-effective-date`}>Effective date: {date}</p>
    </div>
  </section>
);

export const LegalContact = ({ n, prefix }) => (
  <>
    <h2 className="text-2xl font-bold text-gray-900 mb-4">{n}. Contact us</h2>
    <div className="bg-gray-50 p-6 rounded-lg mb-6" data-testid={`${prefix}-contact`}>
      <p className="text-gray-700"><strong>White Paper Accounts Auditing LLC SP</strong></p>
      <p className="text-gray-600">Office 109, Midaffa Building</p>
      <p className="text-gray-600">Musab Bin Omair Street, Al Mahatta</p>
      <p className="text-gray-600">Sharjah, United Arab Emirates</p>
      <p className="text-gray-600">Email: <a href="mailto:info@wpaauae.com" className="text-teal-700 hover:underline">info@wpaauae.com</a></p>
      <p className="text-gray-600">Mobile: <a href="tel:+971501219341" className="text-teal-700 hover:underline">+971 50 121 9341</a></p>
      <p className="text-gray-600">Office: <a href="tel:+97167447940" className="text-teal-700 hover:underline">+971 6 744 7940</a></p>
    </div>
  </>
);

export const LegalBackHome = ({ prefix }) => (
  <div className="mt-8 pt-8 border-t">
    <Link to="/">
      <Button variant="outline" className="flex items-center space-x-2" data-testid={`${prefix}-back-home`}>
        <ArrowLeft size={18} />
        <span>Back to Home</span>
      </Button>
    </Link>
  </div>
);
